
import React from 'react';
import Slider from "react-slick";

const Link = require("react-router-dom").Link;

function DashBoardSlider(props) {
  const { alert, type } = props;

  const { todayUnhealthy, todayHealthy, totalOrgFaculty, totalOrgStudent, todayScanOrgFaculty, todayScanOrgStudent, totalScanChildren, totalChild } = alert;
  const SETTINGS = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: type === 'PARENTS' || type === 'FACULTY' || type === 'STUDENT' ? 3 : 4,
    slidesToScroll: type === 'PARENTS' || type === 'FACULTY' || type === 'STUDENT' ? 3 : 4,
    autoplay: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          className: "center",
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="slider">
      <Slider {...SETTINGS}>
        {
          type === 'STUDENT' || type === 'FACULTY' ?
            <Link to={{
              pathname: `/reports-and-analytics`,
              editProps: "ALL"
            }}>
              {/* <StudentLastScan alert={alert.latestAlert} /> */}
            </Link>
            : null
        }
        <Link to={{
          pathname: `/reports-and-analytics`,
          editProps: "UNHEALTHY"
        }}>
          <div className={`slider-content unhealthy ${type === 'STUDENT' || type === 'FACULTY' ? 'children-scans d-flex align-items-center justify-content-center' : ''}`}>
            <div className="d-flex align-items-center flex-column">
              <div className={`d-flex align-items-center justify-content-around w-100 ${(type === 'STUDENT' || type === 'FACULTY') && (alert && alert.latestAlert !== null) ? 'pb-4' : 'pb-2'}`}>
                <div className="flex-column">
                  <h4 className="count">{todayUnhealthy || 0}</h4>
                </div>
                {/* <img src={Unhealthy} className="img-fluid" alt="Unhealty Alerts" /> */}
              </div>
              <div className="title">
                Unhealty Alerts
              </div>
            </div>
          </div>
        </Link>
        <Link to={{
          pathname: `/reports-and-analytics`,
          editProps: "HEALTHY"
        }}>
          <div className={`slider-content healthy ${type === 'STUDENT' || type === 'FACULTY' ? 'children-scans d-flex align-items-center justify-content-center' : ''}`}>
            <div className="d-flex align-items-center flex-column">
              <div className={`d-flex align-items-center justify-content-around w-100 ${(type === 'STUDENT' || type === 'FACULTY') && (alert && alert.latestAlert !== null) ? 'pb-4' : 'pb-2'}`}>
                <div className="flex-column">
                  <h4 className="count">{todayHealthy || 0}</h4>
                </div>
                {/* <img src={Healthy} className="img-fluid" alt="Healty Alerts" /> */}
              </div>
              <div className="title">
                Healthy Alerts
              </div>
            </div>
          </div>
        </Link>
        {
          type === 'PARENTS' ?
            <div className="slider-content studentscans">
              <div className="d-flex align-items-center flex-column">
                <div className="d-flex align-items-center justify-content-around w-100 pb-4">
                  <div className="d-flex flex-wrap pr-2">
                    <h4 className="count">{totalScanChildren || 0}/</h4>
                    <h4 className="count">{totalChild || 0}</h4>
                  </div>
                  {/* <img src={Scans} className="img-fluid" alt="Children Scan" /> */}
                </div>
                <div className="title">
                  Children Scanned
                </div>
              </div>
            </div>
            : null
        }
        {
          type === 'ORGANIZATION' || type === 'SUBSCRIBER' ?
            <Link to={{ pathname: `/students` }}>
              <div className="slider-content studentscans">
                <div className="d-flex align-items-center flex-column">
                  <div className="d-flex align-items-center justify-content-around w-100 pb-2">
                    <div className="d-flex flex-wrap pr-2">
                      <h4 className="count">{todayScanOrgStudent || 0}/</h4>
                      <h4 className="count">{totalOrgStudent || 0}</h4>
                    </div>
                    {/* <img src={Scans} className="img-fluid" alt="Student Alerts" /> */}
                  </div>
                  <div className="title">
                    Student Scanned
                  </div>
                </div>
              </div>
            </Link>
            : null
        }
        {
          type === 'ORGANIZATION' || type === 'SUBSCRIBER' ?
            <Link to={{ pathname: `/faculties` }}>
              <div className="slider-content facultyscans">
                <div className="d-flex align-items-center flex-column">
                  <div className="d-flex align-items-center justify-content-around w-100 pb-2">
                    <div className="d-flex flex-wrap pr-2">
                      <h4 className="count">{todayScanOrgFaculty || 0}/</h4>
                      <h4 className="count">{totalOrgFaculty || 0}</h4>
                    </div>
                    {/* <img src={Scans} className="img-fluid" alt="Faculty Alerts" /> */}
                  </div>
                  <div className="title">
                    Faculty Scanned
                  </div>
                </div>
              </div>
            </Link>
            : null
        }
      </Slider>
    </div>
  );
}
export default DashBoardSlider;